import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material";
import React, { useEffect, useRef } from "react";
import { gaps , colors } from "theme/defaultStyle";
import ManageSignaturesIcon from "theme/icons/ManageSignaturesIcon";
import { useLookup } from "utils/context/LookupContext";
import { useSignatureDefaults } from "utils/context/SignatureDefaultsContext";
// import { useSignatures } from "utils/context/SignaturesContext";
import SignatureSectionProvider from "../../providers/manage-signature";
// import SignatureDialog from "../signature-dialog";
import SignaturesTable from "./SignaturesTable";
import { useGlobalAccess } from "utils/context/GlobalAccessContext";
import SignatureDefaults from "../signature-defaults/SignatureDefaults";
import CollapsableFormSection from "controls/global/collapsable-form-section/CollapsableFormSection";
import PageSectionPageTitle from "controls/global/page-section/PageSectionPageTitle";

type Props = {
  titleRef?: React.MutableRefObject<any>;
};

const SUB_HEADING_TEXT = `Add a new signature or view/edit an existing signature. Signatures designated as “Agency-Wide” will be available to all users who have access to the assigned agencies`;

const SectionContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: gaps.large1,
});

const ManageSignatures = ({ titleRef }: Props) => {
  // const [, {getSignatures}] = useSignatures();
  const [, { setAgencyWideLevelCode, setUserOnlyLevelCode }] = useSignatureDefaults();
  const [{ selectedAgency }] = useGlobalAccess();
  const defaultSignaturesTitleRef = useRef<HTMLElement>();
  const [
    { signatureLevelTypes },
    { getSignatureImageFontTypes, getSignatureImageFormatTypes, getSignatureImageSourceTypes, getSignatureLevelTypes },
  ] = useLookup();

  // const isFirstRender = useRef(true);

  useEffect(() => {

    // // skip 1st run 
    // if (!isFirstRender.current) {
    //   getSignatures(selectedAgency[0]?.CompanyID, { sortColumn: "SignatureImageName" , agencyId : selectedAgency[0]?.CompanyID});
    // }
    // else {
    //   isFirstRender.current = false;
    // }
    
    // getSignatures(selectedAgency[0]?.CompanyID, { sortColumn: "SignatureImageName" , agencyId : selectedAgency[0]?.CompanyID});
    getSignatureImageFontTypes();
    getSignatureImageFormatTypes();
    getSignatureImageSourceTypes();
    getSignatureLevelTypes();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAgency]);

  useEffect(() => {
    const agencyCode = signatureLevelTypes.find((t) => t.isAgencyWide)?.code;
    if (agencyCode) {
      setAgencyWideLevelCode(agencyCode);
    }
    const userCode = signatureLevelTypes.find((t) => t.isUserOnly)?.code;
    if (userCode) {
      setUserOnlyLevelCode(userCode);
    }
  }, [signatureLevelTypes, selectedAgency]);

  return (
    <PageSectionPageTitle
      icon={<ManageSignaturesIcon />}
      title="Signature Management"
      titleRef={titleRef}
      isError={false}
    >
      <SectionContainer>
        <SignatureSectionProvider>
          <CollapsableFormSection index={1} title="Signatures">
            <Box>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={3}
                ml={1.5}
              >
                <Typography className="subheading" sx={{ color: colors.blue01 }}>
                  {SUB_HEADING_TEXT}
                </Typography>
              </Box>
              <Box>
                <SignaturesTable/>
              </Box>

              {/* <SignatureDialog /> */}
            </Box>
          </CollapsableFormSection>

          <SignatureDefaults titleRef={defaultSignaturesTitleRef} />
        </SignatureSectionProvider>
      </SectionContainer>
    </PageSectionPageTitle>
  )
};

export default ManageSignatures;
